import React from 'react';
import { Package } from 'lucide-react';

export const EmptyState = ({ title = 'Nema rezultata', description = 'Promenite filtere ili pretrazivanje.', icon: Icon = Package }) => (
  <div className="flex flex-col items-center justify-center py-20 text-center">
    <div className="h-16 w-16 rounded-full bg-muted flex items-center justify-center mb-5">
      <Icon size={28} className="text-muted-foreground" />
    </div>
    <h3 className="font-serif text-lg font-semibold text-foreground mb-2">{title}</h3>
    <p className="text-muted-foreground text-sm font-ui max-w-xs">{description}</p>
  </div>
);
